import { useState } from "react";
import type { Discussion } from "@/mocks/events";

export default function DiscussionList({ items }: { items: Discussion[] }) {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (index: number) => {
    setLiked((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <ul className="mt-6 flex flex-col gap-4">
      {items.map((item, index) => {
        const isLiked = Boolean(liked[index]);
        return (
          <li key={`${item.user}-${index}`} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                {item.user.slice(0, 1)}
              </span>
              <div className="flex flex-col">
                <strong className="font-label text-sm font-medium text-foreground-950">{item.user}</strong>
                <span className="font-label text-xs text-foreground-500">
                  {item.role} · {item.time}
                </span>
              </div>
            </div>
            <p className="mt-3 font-body text-sm leading-relaxed text-foreground-700">{item.content}</p>
            <div className="mt-3 flex items-center gap-4">
              <button
                type="button"
                onClick={() => toggleLike(index)}
                aria-pressed={isLiked}
                className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-label text-xs transition-colors duration-200 ${
                  isLiked
                    ? "border-primary-300 bg-primary-100 text-primary-700"
                    : "border-background-200 text-foreground-500 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                <i className={`${isLiked ? "ri-thumb-up-fill" : "ri-thumb-up-line"} text-sm`} aria-hidden="true"></i>
                {item.likes + (isLiked ? 1 : 0)}
              </button>
              <span className="inline-flex items-center gap-1.5 font-label text-xs text-foreground-400">
                <i className="ri-chat-1-line" aria-hidden="true"></i>
                回复
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
}